import { render, staticRenderFns } from "./ApplicationLoginReturn.vue?vue&type=template&id=64f25b8e&scoped=true&"
import script from "./ApplicationLoginReturn.vue?vue&type=script&lang=js&"
export * from "./ApplicationLoginReturn.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationLoginReturn.vue?vue&type=style&index=0&id=64f25b8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f25b8e",
  null
  
)

export default component.exports